import { Loader2, Download } from 'lucide-react';
import type { UserPurchase } from '../lib/api';

interface PurchasesListProps {
  purchases: UserPurchase[];
  loading: boolean;
}

export function PurchasesList({ purchases, loading }: PurchasesListProps) {
  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center py-8">
        <Loader2 className="w-6 h-6 animate-spin text-splyt-green mb-2" />
        <p className="text-white/60 text-sm">Завантаження покупок...</p>
      </div>
    );
  }

  if (!purchases.length) {
    return (
      <div className="flex flex-col items-center justify-center py-8">
        <p className="text-white/50 text-sm text-center">
          У вас ще немає покупок. Спробуйте додати безкоштовні або платні роботи з маркетплейсу.
        </p>
      </div>
    );
  }

  const formatPrice = (price: number | undefined) => {
    if (!price) return 'Безкоштовно';
    const uah = price / 100;
    return `${uah.toFixed(0)} ₴`;
  };

  return (
    <div className="space-y-4 pb-4">
      {purchases.map((purchase) => (
        <div
          key={purchase.id}
          className="glass rounded-2xl border border-white/10 p-4 flex flex-col gap-3"
        >
          <div className="flex items-center gap-3">
            {purchase.cover_url && (
              <div className="w-12 h-12 rounded-xl overflow-hidden bg-black/40 flex-shrink-0">
                <img
                  src={purchase.cover_url}
                  alt={purchase.title || 'Cover'}
                  className="w-full h-full object-cover"
                />
              </div>
            )}
            <div className="flex-1">
              <p className="text-white font-semibold text-sm line-clamp-2">
                {purchase.title || 'Без назви'}
              </p>
              <p className="text-xs text-white/50 mt-0.5">
                Формат: <span className="font-medium text-white/70">{purchase.format}</span>
              </p>
              <p className="text-xs text-white/50 mt-0.5">
                {formatPrice(purchase.price_paid)}
              </p>
            </div>
          </div>

          {purchase.files && purchase.files.length > 0 && (
            <div className="mt-1 space-y-2">
              <p className="text-xs font-medium text-white/60">Файли для завантаження:</p>
              {purchase.files.map((file, idx) => (
                <button
                  key={`${purchase.id}-${idx}-${file.url}`}
                  type="button"
                  onClick={() => {
                    if (file.url) {
                      window.open(file.url, '_blank', 'noopener,noreferrer');
                    }
                  }}
                  className="w-full flex items-center justify-between gap-2 px-3 py-2 rounded-xl bg-white/5 hover:bg-white/10 border border-white/10 text-left transition-colors"
                >
                  <div className="flex items-center gap-2">
                    <Download className="w-4 h-4 text-splyt-green flex-shrink-0" />
                    <div>
                      <p className="text-xs text-white/90 line-clamp-1">
                        {file.name || 'Завантажити файл'}
                      </p>
                      {file.type && (
                        <p className="text-[10px] text-white/40 uppercase mt-0.5">
                          {file.type}
                        </p>
                      )}
                    </div>
                  </div>
                  <span className="text-[10px] text-splyt-green font-medium">Відкрити</span>
                </button>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}





